<template>
  <b-container class="py-3 py-md-5">
    <b-row>
      <div class="col-auto d-none d-md-block" style="width: 250px">
        <div class="side">
          <b-input-group class="mb-2 ml-auto search-group">
            <b-input-group-prepend is-text>
              <b-icon-search></b-icon-search>
            </b-input-group-prepend>
            <b-form-input
              v-model="searchVendor"
              placeholder="搜尋廠商名稱"
            ></b-form-input>
            <b-button-close
              class="pr-2"
              v-if="searchVendor"
              @click="clearVendorFilter"
            ></b-button-close>
          </b-input-group>
          <div class="filter-box my-4 p-3">
            <div class="filter-title py-2 mb-2">
              透過以下分類篩選：
            </div>
            <div class="filter-item">
              <div class="filter-item-list">
                <b-form-group label="地區" class="variant-platfor">
                  <b-form-checkbox-group
                    v-model="zone"
                    :options="zone_list"
                    name="filterTag"
                    stacked
                  ></b-form-checkbox-group>
                </b-form-group>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col vendor_list" v-if="vendorList">
        <div
          class="pb-3 d-flex d-md-none justify-content-between align-items-center"
        >
          <b-input-group class="ml-auto search-group d-flex d-md-none">
            <b-input-group-prepend is-text>
              <b-icon-search></b-icon-search>
            </b-input-group-prepend>
            <b-form-input
              v-model="searchVendor"
              placeholder="搜尋廠商名稱"
            ></b-form-input>
            <b-button-close
              class="pr-2"
              v-if="searchVendor"
              @click="clearVendorFilter"
            ></b-button-close>
          </b-input-group>
          <b-button
            variant="link"
            class="nav-link p-0 ml-2"
            :class="{ has_filter: zone.length }"
            v-b-toggle.filterSidebar
            style="width: 60px;"
          >
            <b-icon icon="funnel" variant="platform_main"></b-icon>
            <small class="text-platform_main text-nowrap">篩選</small>
          </b-button>
        </div>
        <div
          class="vendor-item border p-3 p-lg-4 mb-3"
          v-for="item in filteredVendorList"
          :key="item.id"
        >
          <div class="row">
            <div class="col-md-4 col-lg-3">
              <div class="imgBox">
                <img
                  :src="getCompleteImageUrl(item.image_link)"
                  class="card-img-top"
                  :alt="item.company_name"
                />
              </div>
            </div>
            <div class="col-md-8 col-lg-9">
              <div class="mt-3 mt-sm-0">
                <div class="vendor-tite mb-2 mb-sm-3">
                  {{ item.company_name }}
                </div>
                <div class="vendor-description mb-4 mb-sm-3">
                  {{ item.description }}
                </div>
                <div class="vendor-telephone">
                  聯絡電話：
                  <a :href="'tel:' + item.telephone">{{ item.telephone }}</a>
                </div>
              </div>
            </div>
          </div>
          <b-button
            @click="showModal(item.id, item.telephone)"
            class="btn btn-platform_main vendor-button"
          >
            more
          </b-button>
        </div>
        <b-pagination
          v-if="vendorList.data.length"
          align="right"
          v-model="vendorList.current_page"
          :total-rows="vendorList.total"
          :per-page="vendorList.per_page"
          first-number
          last-number
          @click.native="pagination(vendorList.current_page)"
          class="platform_main"
        ></b-pagination>
      </div>
    </b-row>
    <b-sidebar
      id="filterSidebar"
      shadow
      z-index="99"
      right
      backdrop
      title="搜尋篩選"
      class="sidebar"
      header-class="flex-row-reverse border-bottom"
    >
      <div class="px-3 py-2">
        <b-form-group label="地區">
          <b-form-checkbox-group
            v-model="zone"
            :options="zone_list"
            name="filterTag"
            stacked
          ></b-form-checkbox-group>
        </b-form-group>
      </div>
      <template v-slot:footer>
        <b-button block squared @click="clearFilter" variant="platform_main"
          >清除篩選</b-button
        >
      </template>
    </b-sidebar>
    <b-modal
      id="modalVendor"
      hide-footer
      :title="showVendorData ? showVendorData.company_name : ''"
      @hidden="hiddenModal"
    >
      <div class="" v-if="showVendorData">
        <div class="mb-3">
          <img
            :src="getCompleteImageUrl(showVendorData.image_link)"
            :alt="showVendorData.company_name"
            width="100%"
          />
        </div>
        <div>
          <strong>負責人： </strong>
          <span>{{ showVendorData.principal }}</span>
        </div>
        <hr />
        <div>
          <strong>電話： </strong>
          <a class="text-dark" :href="'tel:' + showVendortelephone">{{
            showVendortelephone
          }}</a>
        </div>
        <hr />
        <div>
          <strong>統一編號： </strong>
          <span>{{ showVendorData.tax_id }}</span>
        </div>
        <hr />
        <div>
          <strong>地址： </strong>
          <span>{{
            showVendorData.city_name +
              showVendorData.town_name +
              showVendorData.address
          }}</span>
        </div>
        <hr />
        <div>
          <strong>公司簡介： </strong>
          <div>
            {{ showVendorData.description }}
          </div>
        </div>
      </div>
    </b-modal>
  </b-container>
</template>
<style lang="scss" scoped>
.side {
  position: sticky;
  top: 20px;
}
.sidebar {
  ::v-deep .close {
    margin-left: auto;
    margin-right: 0 !important;
  }
  ::v-deep header {
    font-size: 20px;
  }
  ::v-deep .b-sidebar-footer {
    a {
      color: #fff;
    }
  }
  ::v-deep .custom-checkbox {
    margin: 10px 0;
  }
}
.search-group {
  border: 1px solid #dee2e6;
  max-width: 100%;
  .input-group-text {
    background-color: #fff;
    border: none;
    border-radius: 0;
    color: #bdbdbd;
  }
  .form-control {
    border: none;
    border-radius: 0;
    &:focus {
      box-shadow: none;
    }
  }
}
.filter-box {
  border: 1px solid #dee2e6;
  ::v-deep .custom-checkbox {
    margin: 10px 0;
  }
  & ::v-deep .col-form-label {
    color: #616870;
    padding-bottom: 0;
  }
}
.has_filter {
  position: relative;
  &::after {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    width: 8px;
    height: 8px;
    border-radius: 5px;
    background-color: $platform_main;
  }
}
.vendor_list ::v-deep .pagination {
  .page-item {
    &:first-child {
      .page-link {
        border-radius: 0;
      }
    }
    &:last-child {
      .page-link {
        border-radius: 0;
      }
    }
  }
}
.vendor-item {
  position: relative;
}
.vendor-tite {
  font-size: 20px;
  color: $platform_main;
}
.vendor-description {
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  line-height: 1.5em;
  max-height: 3em;
}
.vendor-telephone {
  ::v-deep a {
    color: #333;
  }
}
.vendor-button {
  position: absolute;
  right: 0;
  bottom: 0;
  border-radius: 0;
  background-color: transparent;
  border: none;
  z-index: 0;
  padding: 0;
  width: 60px;
  line-height: 43px;
  transition: all 0.3s;
  @include media-breakpoint-down(md) {
    opacity: 1;
  }
  &::after {
    content: "";
    position: absolute;
    bottom: 0;
    right: 0;
    width: 0;
    height: 0;
    border-style: solid;
    border-width: 0px 0 70px 100px;
    border-color: transparent transparent $platform_main transparent;
    z-index: -1;
  }
}
</style>
<script>
import { Vendor } from "@/assets/api/platform.js";
import { Toast } from "@/plugins/sweetalert2.js";

export default {
  name: "Vendor",
  props: ["token"],
  data() {
    return {
      searchVendor: "",
      vendorList: null,
      showVendorId: "",
      showVendortelephone: "",
      showVendorprincipal: "",
      showVendorData: null,
      imageOnerror: "/img/image_onerror.jpg",
      zone: [],
      zone_list: [
        {
          text: "北部",
          value: 1
        },
        {
          text: "中部",
          value: 2
        },
        {
          text: "南部",
          value: 3
        },
        {
          text: "東部",
          value: 4
        },
        {
          text: "離島",
          value: 5
        }
      ]
    };
  },
  created() {
    this.getVendor(1);
    if (this.$route.query.search) {
      this.searchVendor = this.$route.query.search;
    }
  },
  computed: {
    filteredVendorList() {
      if (!this.vendorList) return;
      return this.vendorList.data.filter(data => {
        return data.company_name
          .toLowerCase()
          .includes(this.searchVendor.toLowerCase());
      });
    }
  },
  watch: {
    zone() {
      this.getVendor(1);
    },
    showVendorId(val) {
      if (val) {
        Vendor.get(val, this.token)
          .then(res => {
            if (res.status <= 201) {
              this.showVendorData = res.data;
            } else {
              Toast.fire({
                icon: "error",
                title: "廠商資料讀取失敗",
                text: res.data.error
              });
            }
          })
          .catch(error => {
            console.error(error);
          });
      }
    }
  },
  methods: {
    pagination(currentPage) {
      this.getVendor(currentPage);
      window.scrollTo({ top: 0, behavior: "smooth" });
    },
    clearFilter() {
      this.zone = [];
    },
    getCompleteImageUrl(url) {
      return (process.env.VUE_APP_API_BASE_URL || "") + url;
    },
    showModal(id, telephone) {
      this.showVendorId = id;
      this.showVendortelephone = telephone;
      this.$root.$emit("bv::show::modal", "modalVendor", "#btnShow");
      this.onerrorForImg();
    },
    hiddenModal() {
      this.showVendorId = "";
      this.showVendorData = null;
    },
    onerrorForImg() {
      this.$nextTick(() => {
        var imgList = document.querySelectorAll("img");
        Array.prototype.forEach.call(imgList, item => {
          item.onerror = () => {
            item.src = this.imageOnerror;
          };
        });
      });
    },
    clearVendorFilter() {
      this.searchVendor = "";
      this.$router.replace({ query: null });
    },
    getVendor(page) {
      let config = Object.assign({}, this.token);
      config.params = {
        zone: this.zone,
        page: page
      };
      Vendor.get("", config)
        .then(res => {
          if (res.status <= 201) {
            this.vendorList = res.data;
            this.onerrorForImg();
          } else {
            Toast.fire({
              icon: "error",
              title: "廠商資料讀取失敗",
              text: res.data.error
            });
          }
        })
        .catch(error => {
          console.error(error);
        });
    }
  }
};
</script>
